export const MENU_DATA: { label: string; items: { label: string; link: string; tag?: string }[] }[] = [];
